export const SEARCH_EVENT_LOGGING = 'SEARCH_EVENT_LOGGING';
export const SEARCH_INQUIRY_LOGGING = 'SEARCH_INQUIRY_LOGGING';
export const GENERIC_SYSTEM_ERROR = 'There was an error processing the request. Please retry the transaction.';